export const DEMO = "*******";

export const defaultTheme = {
  BORDER_RADIUS: {
    XS: "2px",
    SM: "4px",
    MD: "8px",
    LG: "12px",
    XL: "16px",
  },
  SPACING: {
    XXS: "2px",
    XS: "4px",
    SM: "8px",
    MD: "16px",
    LG: "24px",
    XL: "32px",
  },
  PADDING: {
    SM: "8px",
    MD: "16px",
    LG: "24px",
    XL: "32px",
  },
  MARGIN: {
    SM: "8px",
    MD: "16px",
    LG: "24px",
    XL: "32px",
  },
  COLORS: {
    GREY: "#eee",
    DARK_GREY: "#554F4D",
    MIDDLE_GREY: "#C7C7C7",
    MEDIUM_GREY: "#808080",
    MINDLER_LIGHT_GREY: "#F1F1F2",
    RIPPLE: "#F8F8F8",
    VERY_LIGHT_GREEN: "#e5f0ed",
    GREEN_HOVER: "#36ab80",
    DARK_GREEN: "#033024",
    DARK_GREEN_TEXT: "#133028",
    MEDIUM_GREEN: "#309973",
    MEDIUM_GREEN_OPACITY: "rgba(48, 153, 115, 0.08)",
    DARK_GREEN_OPACITY: "rgba(3, 48, 36, 0.3)",
    BLACK: "#000",
    BLACK_GREY: "#1D1B1B",
    BLACK_GREY_OPACITY: "rgba(29, 27, 27, 0.04)",
    RED: "#f44336",
    LIGHT_RED: "#FBE0E1",
    MINDLER_ORANGE: "#FF9C75",
    MINDLER_LIGHT_ORANGE: "#FFE9D6",
    ORANGE: "#FB916D",
    PURPLE: "#dcc7f5",
    BLUE: "#c7e1f5",
    BLUE_DARK: "#0070D1",
    PINK: "#f3cece",
    LIGHT_ORANGE: "#FEE9E2",
    YELLOW: "#FFEC29",
    STATUS_GREEN: "#309973",
    STATUS_RED: "#F44236",
    STATUS_YELLOW: "#FEC229",
    STATUS_ORANGE: "#FA9146",
    ACTION_BLUE: "#4298F7",
    LIGHT_ACTION_BLUE: "#F3F9FE",

    // New Rebranding Colors
    WHITE: "#fff",
    LIGHT_GREY: "#fefefe",
    PRIMARY: "#F0AFFA",
    PRIMARY_LIGHT: "#FCEBFF",
    PRIMARY_X_LIGHT: "#FDEBFF",
    PRIMARY_DARK: "#E99CF5",
    SECONDARY_LIGHT: "#FFF1E3",
    SECONDARY: "#FA9146",
    SECONDARY_DARK: "#BF5600",
    TERTIARY_GREEN: "#EBF7F2",
    TERTIARY_LIGHT: "#F8F6F2",
    TERTIARY_LIGHT_RED: "#FFE8E9",
    GRAY_BLACK_OPACITY: "rgba(29, 27, 27, 0.5)",
    GRAY_BLACK_6: "rgba(29, 27, 27, 0.06)",
    GRAY_BLACK: "#1D1B1B",
    GRAY_DARK: "#554F4D",
    GRAY: "#8E8D8B",
    GRAY_MEDIUM: "#CECCC4",
    GRAY_LIGHT: "#F5F3F3",
    GRAY_X_LIGHT: "#F8F8F8",
    GRAY_WHITE: "#FFF",
    GRAY_HIGHLIGHT: "#767472",
    GRAY_OPACITY: "#BDBDBD",
    GRAY_SYSTEM: "#656565",
    ERROR: "#C33A0E",
    WARNING: "#FEC229",
    SUCCESS: "#00805E",
    IMAGE_GRAY: "#F8F6F2",
    BRAND_BLUE: "#BBECFF",
    BRAND_ORANGE: "#FFC77D",
    BRAND_YELLOW: "#FFEC64",
    BLUE_MEDIUM: "#4298F7",
    BRAND_BLUE_OPACITY: "rgba(187, 236, 255, 0.6)",
    WARM_LIGHT: "#F2F0E9",
  },
  FONT: {
    SIZE: {
      EXTRA_SMALL: "0.625rem",
      SMALL: "0.75rem",
      SMALL_MEDIUM: "0.875rem",
      STANDARD: "1rem",
      MEDIUM: "1.125rem",
      LARGE: "1.25rem",
      MEDIUM_LARGE: "1.375rem",
      EXTRA_LARGE: "1.5rem",
      BODY: "16px",
    },
    WEIGHT: {
      THIN: "100",
      ULTRALIGHT: "200",
      LIGHT: "300",
      REGULAR: "400",
      MEDIUM: "500",
      SEMIBOLD: "600",
      BOLD: "700",
      HEAVY: "800",
      BLACK: "900",
    },
    FAMILY: {
      HEADERS: "InterDisplay",
      BODY: "Inter",
      TEXT_BOLD: "Inter",
    },
  },
  BREAKPOINTS: {
    MD: "768px",
    LG: "1024px",
    XL: "1440px",
  },
  TRANSITION: {
    STANDARD_TRANSITION: "0.3s ease-in-out",
  },
  ICON_SIZE: {
    STANDARD: "20px",
    SMALL: "18px",
  },
  LINE_HEIGHT: {
    NORMAL: 1.4,
    TIGHT: 1.35,
  },
} as const;
